import React from 'react';
import { Tabs, Tab } from '@heroui/react';

interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface ProfileTabsProps {
  tabs: TabItem[];
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ tabs }) => {
  return (
    <div className='flex w-full flex-col'>
      <Tabs aria-label='Dynamic tabs' items={tabs}>
        {(item) => (
          <Tab key={item.id} title={item.label}>
            {item.content}
          </Tab>
        )}
      </Tabs>
    </div>
  );
};

export default ProfileTabs;
